export default {
  resetZoom: 'Reset zoom',
  tool: {
    zoomXy: 'Zoom',
    zoomX: 'Zoom X',
    zoomY: 'Zoom Y',
    pan: 'Pan',
  },
};
